<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse accordion :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: Project ... "
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getKategori"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :tabbedTransactional="true"
        :loading="loading"
        title="UM PP Report List"
        createLink="lapUmppCreate"
        manifestLink="lapUmppManifest"
        editLink="lapUmppEdit"
        draftEditLink="lapDraftUmppEdit"
        :dataList="searching"
        :draftList="draftList"
        :price="true"
        :allowcancel="false"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";
export default {
  name: "listPP",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      draftList: [],
      basedList: [],
      kategori: undefined,
      searchDate: [],
      search: "",
      status: undefined,
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getKategori",
      "getDefaultDateFormat",
    ]),
    searching() {
      var self = this;
      let output = this.dataList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate && this.searchDate.length > 0) {
        let startDt = moment(this.searchDate[0]).format(this.getDefaultDateFormat);
        let endDt = moment(this.searchDate[1]).format(this.getDefaultDateFormat);

        output = output.filter(
          (obj) =>
            obj.tgl_buat &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) >= startDt &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) <= endDt
        );
      }

      if (this.kategori) {
        output = output.filter((item) => {
          return item.kategori === self.kategori;
        });
      }

      if (this.status) {
        output = output.filter(
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return output;
    },
  },
  methods: {
    moment,
    fetchData() {
      const laporan = axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pp",
        params: {
          tlc: this.getAuth.username,
          jenis: "Laporan",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      const draft = axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pp",
        params: {
          tlc: this.getAuth.username,
          jenis: "Draft",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return axios
        .all([
          laporan.catch((err) => {
            return null;
          }),
          draft.catch((err) => {
            return null;
          }),
        ])
        .then((response) => {
          if (response[0] !== undefined) {
            this.basedList = response[0].data.data;

            _.forEach(response[0].data.data, (data) => {
              this.dataList.push({
                title: data.no_lk,
                timeline: JSON.parse(data.status_app),
                unread: data.unread == "1" ? true : false,
                subdesc: [
                  this.moment(data.tgl_buat).format(this.getDefaultDateFormat),
                  this.formatCurrency(data.mata_uang, data.total_pemakaian),
                  "Category : "+(data.isparsial=='1' ? "PARSIAL" :"FINAL"),
                ],
                status: data.status,
                id: data.id_manifest,
                price: data.grand_total,
                mata_uang: data.currency,
                kategori: data.kategori,
                tgl_buat: data.tgl_buat,
                searchQ: data.no_lk + " " + data.total_pemakaian,
              });
            });
          } else {
            this.dataList = [];
            this.basedList = [];
          }
          if (response[1] !== undefined) {
            response[1].data.data.forEach((data) => {
              this.draftList.push({
                title: data.no_um,
                subdesc: [
                  data.allocation,
                  moment(data.tanggal).format(this.getDefaultDateFormat),
                  data.deskripsi,
                  "Category : "+(data.isparsial=='1' ? "PARSIAL" :"FINAL"),
                ],
                status: data.status,
                id: data.id_lk_draft,
                price: data.grand_total,
                mata_uang: data.currency,
              });
            });
          } else {
            this.draftList = [];
          }

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
</style>